import { useLocalSearchParams } from 'expo-router';
import CookingPlanScreen from '../../../src/components/cookingPlan/CookingPlanScreen';

export default function CookingPlanRoute() {
  const { date } = useLocalSearchParams<{ date: string }>();
  if (!date) return null;
  return <CookingPlanScreen date={date} />;
}
